import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.CustomerServiceProxy,
        ApiServiceProxies.CustomerInvoiceHeadServiceProxy,
        ApiServiceProxies.CustomerReturnInvoiceServiceProxy,
        ApiServiceProxies.CustomerReturnInvoiceLineServiceProxy,
        ApiServiceProxies.CustomerChequeServiceProxy,
        ApiServiceProxies.SupplierServiceProxy,
        ApiServiceProxies.GovernorateServiceProxy,
        ApiServiceProxies.CityServiceProxy,
        ApiServiceProxies.ExternalManufacturerServiceProxy,
        ApiServiceProxies.ProductServiceProxy,
        ApiServiceProxies.SupplierInvoiceHeadServiceProxy,
        ApiServiceProxies.RawStockServiceProxy,
        ApiServiceProxies.RawMaterialServiceProxy,
        ApiServiceProxies.SeasonServiceProxy,
        ApiServiceProxies.SupplierInvoiceLineServiceProxy,
        ApiServiceProxies.CustomerInvoiceLineServiceProxy,
        ApiServiceProxies.MeasureUnitServiceProxy,
        ApiServiceProxies.GovernorateServiceProxy,
        ApiServiceProxies.ColorServiceProxy,
        ApiServiceProxies.SupplierChequeServiceProxy,
        ApiServiceProxies.StockTransactionServiceProxy,
        ApiServiceProxies.SupplierTransactionServiceProxy,
        ApiServiceProxies.ProductionOrderServiceProxy,
        ApiServiceProxies.ManufacturingCardServiceProxy,
        ApiServiceProxies.WorkerServiceProxy,
        ApiServiceProxies.WorkerAttendanceTransactionServiceProxy,
        ApiServiceProxies.WorkerFinancialTransactionServiceProxy,
        ApiServiceProxies.JobServiceProxy,
        ApiServiceProxies.FileUploadServiceProxy,
        ApiServiceProxies.ProductionOrderSplitServiceProxy,
        ApiServiceProxies.MachineServiceProxy,
        ApiServiceProxies.WarehouseServiceProxy,
        ApiServiceProxies.ProductionOrderSplitReceiveServiceProxy,
        ApiServiceProxies.RawMaterialUnitSettingServiceProxy,
        ApiServiceProxies.CategoryServiceProxy,
        ApiServiceProxies.ProductStockTransactionServiceProxy,
        ApiServiceProxies.DashboardServiceProxy,
        ApiServiceProxies.ProductStockServiceProxy,
        ApiServiceProxies.ExternalManufacturerTransactionServiceProxy,
        ApiServiceProxies.CustomerTransactionServiceProxy,
        ApiServiceProxies.ExpensesServiceProxy,
        ApiServiceProxies.ExternalManufacturerFinancialTransactionServiceProxy,
        ApiServiceProxies.ManufacturerReportServiceProxy,
        ApiServiceProxies.WorkerReportServiceProxy,
        ApiServiceProxies.SupplierReportServiceProxy,
        ApiServiceProxies.ProductReportServiceProxy,
        ApiServiceProxies.CustomerReportServiceProxy,
        ApiServiceProxies.RawReportServiceProxy,
        ApiServiceProxies.InquiryRequestServiceProxy,
        ApiServiceProxies.PartnerFactoryServiceProxy,
        ApiServiceProxies.PartnerFactoryReportServiceProxy,
        ApiServiceProxies.PartnerFactoryTransactionServiceProxy,
        ApiServiceProxies.TextilePrintingTransactionServiceProxy,
        ApiServiceProxies.TextilePrintingFinancialTransactionServiceProxy,
        ApiServiceProxies.TextilePrintingServiceProxy,
        ApiServiceProxies.TextilePrintingReportServiceProxy,
        ApiServiceProxies.EmbroideryServiceProxy,
        ApiServiceProxies.EmbroideryFinancialTransactionServiceProxy,
        ApiServiceProxies.EmbroideryTransactionServiceProxy,
        ApiServiceProxies.EmbroideryReportServiceProxy,
        ApiServiceProxies.ProductTransferServiceProxy,
        ApiServiceProxies.RawMaterialTransferServiceProxy,
        ApiServiceProxies.PriceListServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule {}
